import { render, staticRenderFns } from "./SimularPlanoSaude.vue?vue&type=template&id=7d91ee4a&"
import script from "./SimularPlanoSaude.vue?vue&type=script&lang=js&"
export * from "./SimularPlanoSaude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports